
import axios from "axios";
import {apiUrl} from '../AxiosAPI' ;  

  



// Create Folder API post call with rest endpoint 
export const AWSFilePresignedURL= (folderAPIData) => axios.post(`${apiUrl}/AWSFilePresignedURL`,folderAPIData);  
 
// Create Folder API post call with rest endpoint 
export const createNewFolder= (folderAPIData) => axios.post(`${apiUrl}/createNewFolder`,folderAPIData);  
 
// Get All Folders API post call with rest endpoint 
export const getAllFoldersByApp= (folderAPIData) => axios.post(`${apiUrl}/getAllFoldersByApp`,folderAPIData);  
 
 
// Rearrange Folders API post call with rest endpoint 
export const reArrangeFolders= (APIData) => axios.post(`${apiUrl}/reArrangeFolders`,APIData);  
 
// create/Update List name & status  API post call with rest endpoint 
export const createNewList= (APIData) => axios.post(`${apiUrl}/createNewList`,APIData);  
 
// get All List Data In  App  API post call with rest endpoint 
export const getAllListsByApp= (APIData) => axios.post(`${apiUrl}/getAllListsByApp`,APIData);  
// get All List Data In  App  API post call with rest endpoint 
export const addFolderToListAPI= (APIData) => axios.post(`${apiUrl}/addFolderToList`,APIData);  

// create/Update SubCourse name & status  API post call with rest endpoint 
export const createNewSubCourse= (APIData) => axios.post(`${apiUrl}/createNewSubCourse`,APIData);  

// create/Update Milestone name & status  API post call with rest endpoint 
export const createNewMilestone= (APIData) => axios.post(`${apiUrl}/createNewMilestone`,APIData);  

// get All get All SubCourses  In a Course API post call with rest endpoint 
export const getAllSubCoursesByCourseId= (APIData) => axios.post(`${apiUrl}/getAllSubCoursesByCourseId`,APIData);  

// get All get All Milestones  In a Sub Course API post call with rest endpoint 
export const getAllMilestonesBySubCourseId= (APIData) => axios.post(`${apiUrl}/getAllMilestonesBySubCourseId`,APIData);  

// Rearrange SubCourses API post call with rest endpoint 
export const reArrangeSubCourses= (APIData) => axios.post(`${apiUrl}/reArrangeSubCourses`,APIData);  



// create/Update Section name & status  API post call with rest endpoint 
export const createNewSection= (APIData) => axios.post(`${apiUrl}/createNewSection`,APIData);  

// get All get All Sections  In a Course API post call with rest endpoint 
export const getAllSectionsByMilestoneId= (APIData) => axios.post(`${apiUrl}/getAllSectionsByMilestoneId`,APIData);  

// Rearrange Sections API post call with rest endpoint 
export const reArrangeSections= (APIData) => axios.post(`${apiUrl}/reArrangeSections`,APIData);  


// create/Update Chapter name & status  API post call with rest endpoint 
export const createNewChapter= (APIData) => axios.post(`${apiUrl}/createNewChapter`,APIData);  
 
// get All get All Chapters  In a Course API post call with rest endpoint 
export const getAllChaptersBySectionId= (APIData) => axios.post(`${apiUrl}/getAllChaptersBySectionId`,APIData);  

// Rearrange Chapters API post call with rest endpoint 
export const reArrangeChapters= (APIData) => axios.post(`${apiUrl}/reArrangeChapters`,APIData);  



// create/Update Chapter name & status  API post call with rest endpoint 
export const addEntityToAnyEntity= (APIData) => axios.post(`${apiUrl}/addEntityToAnyEntity`,APIData);  
 
export const getAllContentsBySectionId= (APIData) => axios.post(`${apiUrl}/getAllContentsBySectionId`,APIData);  
 
export const createNewLessonForCourseByAdmin= (APIData) => axios.post(`${apiUrl}/createNewLessonForCourseByAdmin`,APIData);  
export const getAllFilesBys3Key= (APIData) => axios.post(`${apiUrl}/getAllFilesBys3Key`,APIData);  
export const getAllFileListByUser= (APIData) => axios.post(`${apiUrl}/getAllFileListByUser`,APIData);  
export const manageFileListNamesByUser= (APIData) => axios.post(`${apiUrl}/manageFileListNamesByUser`,APIData);  
export const createNewFileListEntryByUser= (APIData) => axios.post(`${apiUrl}/createNewFileListEntryByUser`,APIData);  

export const createNewMockTopic= (APIData) => axios.post(`${apiUrl}/createNewMockTopic`,APIData);  

export const createNewEntryToMockTopic= (APIData) => axios.post(`${apiUrl}/createNewEntryToMockTopic`,APIData);  

export const createNewRichContent= (APIData) => axios.post(`${apiUrl}/createNewRichContent`,APIData);  

